export default __webpack_public_path__ + "static/media/farmaciarhaizes.2794bc87.jpeg";